<template>
    <div class="page" v-if=' data === null || data.error '>
        에러
    </div>

    <div class="page" v-else>
        <h1 v-html=' data.title ' />
        <transition-group name="slide-fade">
            <div v-for=' (item, idx) in data.datas ' :key='idx'
                class="compo" :class='{admin: isAdmin, oops: !isAdmin }'
            >
                <text-html v-if=' item.type==="text" ' :data='item' />
                <code-highlight v-else-if=' item.type==="code" ' :data='item' :isAdmin='isAdmin'/>
                <code-highlight-origin v-else-if=' item.type==="code2" ' :data='item' :isAdmin='isAdmin'/>
                <iv v-else-if=' item.type==="img" ' :data='item' />
                <h2 v-else-if=' item.type==="subtitle" ' v-html='item.content' />
                <youtube v-else-if=' item.type==="youtube" ' :data='item' />
                <exlink v-else-if=' item.type==="link" ' :data='item' />
                <collapse v-else-if=' item.type==="Collapse" ' :data='item' :isAdmin='isAdmin'/>
                <next v-else-if=' item.type==="next" ' :data='item' />
                <sb-oxq v-else-if=' item.type==="oxquiz" ' :data='item' />
                <sb-mcq v-else-if=' item.type==="quiz" ' :data='item' />
                <tab v-else-if=' item.type==="tab" ' :data='item' :isAdmin='isAdmin'
                    :titleGroup=' titleGroup ' @set-group=' setTabGroup '/>

                <div v-if=' isAdmin ' class="adminbox" @click=' visibleUpdate(idx+1) '><span>{{idx}}</span></div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import TextHtml from './sections/TextHtml.vue';
import CodeHighlight from './sections/CodeHighlight.vue';
import CodeHighlightOrigin from './sections/CodeHighlight.origin.vue';
import Image from './sections/ImageLink.vue';
import Youtube from './sections/Youtube.vue';
import ExternalLink from './sections/ExternalLink.vue';
import Collapse from './sections/Collapse.vue';
import NextButton from './sections/NextButton.vue';
import OXQuiz from './sections/OXQuiz.vue';
import MCQuiz from './sections/MCQuiz.vue';
import Tab from './sections/Tab.vue';

export default {
    name: 'sb-section',
    components: {
        "text-html": TextHtml,
        "code-highlight": CodeHighlight,
        "code-highlight-origin": CodeHighlightOrigin,
        "iv": Image,
        "youtube": Youtube,
        "exlink": ExternalLink,
        "collapse": Collapse,
        "next": NextButton,
        "sb-oxq": OXQuiz,
        "sb-mcq": MCQuiz,
        "tab": Tab,
    },
    props: {
        isAdmin: { type: Boolean },
        page: { type: [Number, String] },
        data: { type: [Object, undefined] },
    },
    data(){
        return {
            titleGroup: ""
        }
    },
    created(){
        // console.log(this.data);
        window.scrollTo(0,0);
    },
    methods: {
        visibleUpdate(compoNum){
            if( this.isAdmin ){
                this.DBref.child('page').child(this.page).set({view: compoNum}); // 5번째 컴포까지 보이게
            }
        },
        setTabGroup( group ){
            this.titleGroup = group;
        }
    }
}
</script>

<style>
.compo {
    position: relative;
}
.compo.admin {
    border-bottom: 1px dashed #eee;
}
.compo.admin.oops {
    opacity: 0.5;
}
.compo.admin:hover {
    border-bottom: 2px dashed #008080;
}
.adminbox{
    position: absolute;
    right: -100px;
    bottom: 0;
    width: 100px;
    height: 100%;
    text-align: center;
    color: #008080;
    cursor: pointer;
}
.adminbox>span {
    position: absolute;
    bottom: 0;
}
</style>

